import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AnxietySection from './components/AnxietySection';
import EntryActionSection from './components/EntryActionSection';
import ContentGuide from './components/ContentGuide';
import TrustSection from './components/TrustSection';
import NewArticlesSection from './components/NewArticlesSection';
import ArticleList from './components/ArticleList';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import RequestFormModal from './components/RequestFormModal';
import HomeSEO from '../../components/feature/HomeSEO';

export default function Home() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <main className="min-h-screen bg-[#FAFAF8]">
      <HomeSEO />
      <Navbar />

      {/* ①ファーストビュー */}
      <Hero onOpenModal={handleOpenModal} />

      {/* ②鳥取の悩み共感（地域特化3選） */}
      <AnxietySection />

      {/* ③入口アクション（あなたに合った入口から始めよう） */}
      <EntryActionSection />

      {/* ④家づくりステップ案内 */}
      <ContentGuide />

      {/* ⑤信頼性セクション */}
      <TrustSection onOpenModal={handleOpenModal} />

      {/* 新着記事（1週間以内） */}
      <NewArticlesSection />

      {/* 記事一覧（人気ランキング） */}
      <ArticleList onOpenModal={handleOpenModal} />

      {/* ⑥CTAセクション */}
      <CTASection onOpenModal={handleOpenModal} />

      {/* ⑦フッター */}
      <Footer />

      {/* 資料請求モーダル */}
      <RequestFormModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </main>
  );
}
